// SoyTiendaPage.jsx
// Route: /
// Assembles: SoyTiendaHeader + all tienda sections + MarketplaceFooter

import React from "react";
import { SoyTiendaHeader }    from "./shared/SoyTiendaHeader";
import { MarketplaceFooter }  from "./shared/MarketplaceFooter";
import { WhatsAppFloat }      from "./shared/WhatsAppFloat";
import { HeroSection }        from "./tienda/HeroSection";
import { StatsStrip }         from "./tienda/StatsStrip";
import { ModalidadesSection } from "./tienda/ModalidadesSection";
import { ProcesoSection }     from "./tienda/ProcesoSection";
import { TecnologiaSection }  from "./tienda/TecnologiaSection";
import { CoberturaSection }   from "./tienda/CoberturaSection";
import { PricingSummarySection } from "./tienda/PricingSummarySection";
import { CtaBanner }          from "./tienda/CtaBanner";

export default function SoyTiendaPage() {
  return (
    <div className="min-h-screen font-sans antialiased text-slate-900 flex flex-col" style={{ background: "#FFF8FB" }}>
      <SoyTiendaHeader />

      <main className="flex-1">
        <HeroSection />
        <StatsStrip />
        <TecnologiaSection />
        <ProcesoSection />
        <ModalidadesSection />
        <PricingSummarySection />
        <CoberturaSection />
        <CtaBanner />
      </main>

      <MarketplaceFooter />
      <WhatsAppFloat />
    </div>
  );
}
